// extracted by mini-css-extract-plugin
export default {"cta":"lF-z","disabled":"mF-z"};